import { Icon } from '@iconify/react';
import Modal from 'react-modal';
import { StyledButton } from '../../../../components/StyledButton';
import { StyledInput } from '../../../../components/StyledInput';
import { InputDescription } from '../InputDescription';
import {
  Container,
  ContentBody,
  ContentFooter,
  ContentHeader,
} from './styles';

interface AnticipationValueModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  handleDesiredValue: () => void;
  handleSetDesiredValue: (value: any) => void;
  desiredValue: number;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',

    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',

    maxHeight: '500px',

    borderRadius: '12px',
  },
};

export function AnticipationValueModal({
  isOpen,
  onRequestClose,
  handleDesiredValue,
  desiredValue,
  handleSetDesiredValue
}: AnticipationValueModalProps) {

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        onRequestClose();
      }}
      contentLabel="Example Modal"
      style={customStyles}
    >
      <ContentHeader>
        <h2>Fazer Antecipação</h2>
      </ContentHeader>
      <ContentBody>
        <Container>
          <div>
            <InputDescription placeholder="Valor desejado" />
            <StyledInput
              placeholder="Inserir valor desejado"
              sizeDisplay="lg"
              icon={<Icon icon="ic:baseline-attach-money" width={24} />}
              iconPosition="right"
              value={desiredValue}
              onChange={handleSetDesiredValue}
            />
          </div>

          <StyledButton
            text="Aplicar"
            icon={
              <Icon icon="iconamoon:arrow-right-6-circle-fill" width={20} />
            }
            iconPosition="right"
            onClick={handleDesiredValue}
            color="#1D5E95"
          />
        </Container>
        <p style={{ fontSize: 13 }}>
          <b>Observação:</b> O valor selecionado após a aplicação será apróximado.
        </p>
        <ContentFooter>
          <StyledButton
            icon={<Icon icon="iconamoon:arrow-left-6-circle-fill" width={20} />}
            iconPosition="left"
            text="Cancelar"
            color="#595044"
            onClick={onRequestClose}
          />
        </ContentFooter>
      </ContentBody>
    </Modal>
  );
}
